import { render, staticRenderFns } from "./DisplayOrderItems.vue?vue&type=template&id=7c8abe5b&scoped=true"
import script from "./DisplayOrderItems.vue?vue&type=script&lang=js"
export * from "./DisplayOrderItems.vue?vue&type=script&lang=js"
import style0 from "./DisplayOrderItems.vue?vue&type=style&index=0&id=7c8abe5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8abe5b",
  null
  
)

export default component.exports